import { Grid, Card, MenuItem, FormControl, Box, CircularProgress, Backdrop } from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "layouts/Tables/DataTable";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { useMaterialUIController, setCustomerContext } from "context";
import configurationContext from "contextConfig";
import { handleErrors } from "common.js";
import PreviewIcon from '@mui/icons-material/Preview';

function CustomerList() {
  const navigate = useNavigate();
  const { pageNo } = useParams();
  var pageSelected = 1;
  const MyContext = useContext(configurationContext);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { customerContext } = controller;
  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [customerData, setData] = useState({});
  const [responseResultCount, setResponseResultCount] = useState(0);
  const searchFilterData = { "searchBy": customerContext.searchBy, "searchValue": customerContext.searchValue, "orderBy": customerContext.orderBy, "orderValue": customerContext.orderValue };
  const [isLoading, setIsLoading] = useState(true);
  const [isCustomerContextChanged, setCustomerContextChanged] = useState(false);

  const data = () => {
    setIsLoading(true);
    toast.dismiss();
    axios({
      url: BASE + "api/customer/list",
      method: "POST",
      data: { ...searchFilterData, pageSelected: pageSelected },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      }
    }).then(function (response) {
      setIsLoading(false);
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data);
          if (response.data.data.totalCount)
            setResponseResultCount(response.data.data.totalCount);
        }
        else {
          toast.error(t(message));
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const handleResetFilters = () => {
    setCustomerContext(dispatch, initialState.customerContext);
    setCustomerContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/customer/list/page-1");
    else
      navigate("/customer/list");
  };

  useEffect(() => {
    const hasChanged = Object.keys(customerContext).some(
      key => customerContext[key] !== initialState.customerContext[key]
    );
    setCustomerContextChanged(hasChanged);
  }, [customerContext]);

  const columns = [
    { Header: t("Id"), accessor: "id", align: "left" },
    { Header: t("Shopify Id"), accessor: "shopifyId", align: "left" },
    { Header: t("First Name"), accessor: "firstName", align: "left" },
    { Header: t("Last Name"), accessor: "lastName", align: "left" },
    { Header: t("Email"), accessor: "email", align: "left" },
    { Header: t("Phone"), accessor: "phone", align: "left" },
    { Header: t("action"), accessor: "action", align: "left" }
  ];
  const finalObj = [];

  if (customerData.data && customerData.data.rows) {
    let customerRecords = customerData.data.rows;
    for (const rowKey in customerData.data.rows) {
      let customerRecord = customerRecords[rowKey];
      if (customerRecord.id > 0) {
        let tempObj = {
          id: '#' + customerRecord.id,
          shopifyId: (customerRecord.shopifyId) ? customerRecord.shopifyId : '-',
          firstName: (customerRecord.firstName) ? customerRecord.firstName : '-',
          lastName: (customerRecord.lastName) ? customerRecord.lastName : '-',
          email: (customerRecord.email) ? customerRecord.email : '-',
          phone: (customerRecord.phone) ? customerRecord.phone : '-',
          action: <span className="actionLinksStyle">
            <MDTypography component="a" href={"#"} onClick={(event) => { event.preventDefault(); navigate("/customer/view/" + customerRecord.id) }} variant="caption" color="text" fontWeight="medium" mr={1}>
              <Tooltip title={t('view')}><Box className="ActionEdit"><PreviewIcon /></Box></Tooltip>
            </MDTypography>
          </span>
        };
        finalObj.push(tempObj);
      }
    }
  }
  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("manageCustomers")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {(Object.keys(customerData).length > 0) ?
        <MDBox pt={6} pb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox className="ManageProductTopSec" mx={2} mt={0} py={3} px={2} variant="gradient">
                  <Grid container className="FilterSectionBox" spacing={2}>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="searchBy"
                        label={t('searchBy')}
                        value={searchFilterData.searchBy}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        onChange={(obj) => {
                          if (obj.target.value == 'none') {
                            setCustomerContext(dispatch, { ...customerContext, searchValue: '', searchBy: obj.target.value });
                          }
                          else
                            setCustomerContext(dispatch, { ...customerContext, searchBy: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'none'}>{t('none')}</MenuItem>
                        <MenuItem value={'id'}>{t('id')}</MenuItem>
                        <MenuItem value={'shopifyId'}>{t('shopify id')}</MenuItem>
                        <MenuItem value={'name'}>{t('name')}</MenuItem>
                        <MenuItem value={'email'}>{t('email')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} >
                      <FormControl >
                        <MDInput
                          key={'searchValue'}
                          value={searchFilterData.searchValue}
                          disabled={(searchFilterData.searchBy == 'none') ? true : false}
                          type="text" name="searchValue" label={t("searchInput")}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={(obj) => {
                            setCustomerContext(dispatch, { ...customerContext, searchValue: obj.target.value });
                          }} fullWidth />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="orderBy"
                        value={searchFilterData.orderBy}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        label={t('orderBy')}
                        onChange={(obj) => {
                          setCustomerContext(dispatch, { ...customerContext, orderBy: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'createdAt'}>{t('createdAt')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <MDInput
                        select
                        name="orderValue"
                        value={searchFilterData.orderValue}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        label={t('order')}
                        onChange={(obj) => {
                          setCustomerContext(dispatch, { ...customerContext, orderValue: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                        <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                      <FormControl className="filterSubmit">
                        <MDButton
                          onClick={() => {
                            navigate("/customer/list");
                            if (typeof pageNo === "undefined")
                              data();
                          }}
                          key="submit" type="submit" color="info" size="small" className="SubmitButton" disableRipple fullWidth>{t('submit')}</MDButton>
                        {isCustomerContextChanged && (
                          <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    showTotalEntries={true}
                    responseResultCount={responseResultCount}
                    paginationSize={MyContext.paginationSize}
                    paginationLink={"/customer/list/page-"}
                    pageSelected={pageSelected}
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}

export default CustomerList;
